/**
 * There will be one reducer file per page / common component
 */
 import {
    GET_SEARCH_PARAM,
    GET_SEARCH_PARAM_SUCCESS,
    GET_SEARCH_PARAM_FAILURE
} from 'src/pages/more/pages/templates/redux/action/actionTypes.js';

const initialState = {
    loading: false,
    searchParamList:{}
};

const FilterParamReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SEARCH_PARAM:
            return {
                ...state,
                loading: true,
                searchParamList: action.payload,
            };
        case GET_SEARCH_PARAM_SUCCESS:
            return {
                ...state,
                loading: false,
                searchParamList: action.payload.searchParamList,
            };
        case GET_SEARCH_PARAM_FAILURE:
            return {
                ...state,
                loading: false,
            };
        default: {
            return { ...state };
        }
    }
};

export default FilterParamReducer;
